import { styled } from '@linaria/react';

import { hoverable } from '~shared/ui/theme/snippets';

export const OpenFeedContainer = styled.div`
	${hoverable}
	flex-shrink: 0;
	color: var(--color-white-solid);
	grid-area: btn;
	transition: filter 0.2s, transform 0.1s;

	@media (hover: hover), (-moz-touch-enabled: 0), (pointer: fine) {
		&:hover {
			filter: drop-shadow(2px 2px 8px var(--color-white-solid));
		}
	}

	@media (hover: hover) {
		&:hover {
			transform: scale(1.2);
		}
	}
`;
